import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import {AsyncPipe, NgFor, NgIf} from '@angular/common';
import {
  ApiService,
  BaseComponent,
  CustomToasterService,
  Organization,
  ProfileService,
} from '@app-utils';
import { ButtonComponent, IconComponent, ModalComponent } from '@app-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';

interface CustomOrganization extends Organization {
  extId: string;
}

@Component({
  selector: 'core-organization-switch-modal',
  templateUrl: './organization-switch-modal.component.html',
  styleUrl: './organization-switch-modal.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgFor,
    ModalComponent,
    NgIf,
    IconComponent,
    TranslateModule,
    ButtonComponent,
    AsyncPipe,
  ],
})
export class OrganizationSwitchModalComponent extends BaseComponent {
  private readonly _customToaster = inject(CustomToasterService);
  private readonly _profileSvc = inject(ProfileService);
  private readonly _api = inject(ApiService);
  private readonly _translate = inject(TranslateService);
  private readonly _router = inject(Router);

  @Input() isVisible = false;

  @Input() closable = false;

  @Input() organizationList: Organization[] = [];

  @Input() orgId = '';

  @Output() organizationChange = new EventEmitter<Organization>();

  @Output() close = new EventEmitter<void>();

  get orgList(): CustomOrganization[] {
    return this.organizationList.map((item) => {
      const spl = item.id.split('-');
      return { ...item, extId: spl[spl.length - 1] };
    });
  }

  addCompany(): void {
    this.isVisible = false;
    void this._router.navigate(['/add-org']);
  }

  trackById(index: number, item: Organization): string {
    return item.id;
  }

  logout(): void {
    this._api
      .userLogout()
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this._profileSvc.logout();
        void this._router.navigate(['/auth']);
      });
  }
}
